import React, { useState } from "react";

import CommonLayout from "../../../Components/CommonLayout/CommonLayout";
import RefferalComponent from "../RefferalComponent";

const PromocodeReferral = ({meta}) => {
  const [pagination, setPagination] = useState({
    page: 1,
    limit: 5,
    sortOrder: "desc",
  });

  const handlePagination = (data) => {
    if (data.clearPagination) {
      setPagination(data.clearPagination);
      return;
    }

    setPagination((prev) => {
      let copyfilter = { ...prev.filter };

      if (data.filter) {
        if (copyfilter[Object.keys(data.filter)[0]]) {
          copyfilter[Object.keys(data.filter)[0]] = Object.values(
            data.filter
          )[0];
        } else {
          copyfilter = { ...data?.filter, ...copyfilter };
        }
      }

      return {
        page: data.page ? data.page : prev.page,
        limit: data.limit ? data.limit : prev.limit,
        sortOrder: data.sortOrder ? data.sortOrder : prev.sortOrder,
        filter: copyfilter,
      };
    });
  };

  return (
    <div className="p-5">
      <CommonLayout />

      <RefferalComponent
        pagination={pagination}
        handlePagination={handlePagination}
      />
    </div>
  );
};

export default PromocodeReferral;
